import { useDataStreamStore } from '@/lib/store/dataStream';
import { useCallback } from 'react';
import type { MouseEvent } from 'react';

type Pane = 'tree' | 'messages' | 'detail';
const MIN = 160;
const MAX = 640;

/** Returns an onMouseDown handler that drag-resizes the given pane and
 *  persists the new width to the store. */
export function usePaneResize(pane: Pane) {
  const setPaneWidth = useDataStreamStore((s) => s.setPaneWidth);

  return useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      const startX = e.clientX;
      const startW = useDataStreamStore.getState().paneWidths[pane];
      const onMove = (ev: globalThis.MouseEvent) => {
        const next = Math.min(MAX, Math.max(MIN, startW + (ev.clientX - startX)));
        setPaneWidth(pane, next);
      };
      const onUp = () => {
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('mouseup', onUp);
      };
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
    },
    [pane, setPaneWidth],
  );
}
